"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var Types = require("types");
var ProjectActions = require("@caddigital/sok-reducers/lib/actions/projects");
var constants_1 = require("utils/constants");
var mapStateToProps = function (state) {
    return {
        searchString: state.projects.searchString
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    setSearchString: function (value) { return (dispatch(ProjectActions.setSearchString(value)),
        dispatch(ProjectActions.setOffset(0))); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('ProjectListSearch'), (0, recompose_1.withState)('temp', 'setTemp', null), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
var onChangeTimeout;
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'searchbar' },
    React.createElement(sok_ui_1.TextInput, { className: 'sok-text-input white search-box', value: props.temp !== null ? props.temp : props.searchString, placeholder: (0, translation_1.getLocalization)('userFront/projectsTab/search/searchForProjects'), onChange: function (event) {
            var val = event.target.value;
            props.setTemp(val);
            if (onChangeTimeout) {
                clearTimeout(onChangeTimeout);
            }
            onChangeTimeout = setTimeout(function () {
                props.setSearchString(val);
                props.setTemp(null);
            }, constants_1.SEARCH_TIMEOUT);
        }, icon: React.createElement(Icon_1.Icon, { className: 'fa-search' }) }))); });
